import { signOut as authSignout } from "@aws-amplify/auth";
import { useQueryClient } from "react-query";

export const useGlobalSignout = () => {
  const queryClient = useQueryClient();

  const signOut = async () => {
    await authSignout({ global: true });
    queryClient.clear();
  };

  return { signOut };
};
